import React, { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import { useSearchParams } from "react-router-dom";
import { useProductsQuery } from "../../services/productApi";
import CardComponent from "../Home/FeaturedProducts/CardComponent/CardComponent";

const Search = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [page, setPage] = useState(1);

  // Reset to first page whenever the search term changes
  useEffect(() => {
    setPage(1);
  }, [query]);

  const { data, isLoading, isFetching } = useProductsQuery(
    { cat: "all", search: query, page, limit: 8 },
    { skip: !query }
  );

  const products = data?.data;
  const pagination = data?.pagination;

  return (
    <div className="text-center mt-[40px] md:mt-[80px] md:px-4 xl:px-0 w-full min-h-[60vh]">
      <h2 className="uppercase text-[#1717178C] text-2xl md:text-4xl font-medium">
        Search <span className="text-black">Results</span>
      </h2>
      {query && (
        <p className="text-[#545454CC] mt-[15px] px-4">
          Showing results for “<span className="font-semibold">{query}</span>”
        </p>
      )}

      {isLoading || isFetching ? (
        <div className="w-[100%] flex justify-center items-center min-h-[300px]">
          <Oval
            height={80}
            width={80}
            color="#DF5645"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#DF5645"
            strokeWidth={4}
            strokeWidthSecondary={4}
          />
        </div>
      ) : (
        <div className="mt-[30px]">
          {!query || products?.length === 0 ? (
            <div className="h-[200px] flex justify-center items-center">
              <h3 className="text-red-600 text-[21px]">
                {query ? "No products found!" : "Type something to search"}
              </h3>
            </div>
          ) : (
            <>
              <CardComponent data={products} />

              <div className="max-w-[1440px] mt-[20px] flex flex-col-reverse lg:flex-row justify-between items-center gap-[20px] mx-auto lg:w-[96%]">
                <div>
                  Page {page} of {pagination?.totalPages}
                </div>
                <div>Total {pagination?.totalItems} Items</div>
                <div className="flex items-center">
                  {page > 1 ? (
                    <button
                      onClick={() => setPage(page - 1)}
                      className="text-[#DF5645] border-[1px] border-[#DF5645] px-[15px] py-[6px] w-[80px] rounded font-bold mr-[10px] hover:bg-[#DF5645] hover:text-white flex justify-center items-center"
                    >
                      Previous
                    </button>
                  ) : (
                    <button
                      disabled
                      className="text-[grey] border-[1px] border-[grey] px-[15px] py-[6px] w-[80px] rounded font-bold mr-[10px] flex justify-center items-center"
                    >
                      Previous
                    </button>
                  )}
                  {page < pagination?.totalPages ? (
                    <button
                      onClick={() => setPage(page + 1)}
                      className="text-[#DF5645] border-[1px] border-[#DF5645] px-[15px] py-[6px] w-[80px] rounded font-bold ml-[10px] hover:bg-[#DF5645] hover:text-white flex justify-center items-center"
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      disabled
                      className="text-[grey] border-[1px] border-[grey] px-[15px] py-[6px] w-[80px] rounded font-bold ml-[10px] flex justify-center items-center"
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
